<template>
    <div>
        <div class="footCommon">网站版权信息</div>
    </div>
</template>
<script>


export default {
    name:'footersView',
    data(){
        return{

        }
    },
    methods:{
    },
    
}
</script>
<style lang="scss" scoped>
.footCommon {
    width: 100%;
    height: 156px;
    background: #0f59a4;
    font-size: 42px;
    font-weight: normal;
    line-height: 156px;
    letter-spacing: 0em;
    color: #ffffff;
    text-align: center;
}
</style>











